var map = {
	"./badscience.jpg": "e4f3",
	"./coloroflaw.jpg": "fa76",
	"./prisonersofgeography.png": "1459",
	"./therighteousmind.png": "a66c",
	"./winnerstakeall.png": "9e76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "83b3";